import { Injectable } from '@angular/core';
import { TransferState } from '@angular/platform-browser';
import { Apollo } from 'apollo-angular';
import { HttpLink } from 'apollo-angular/http';
import { HttpClient } from '@angular/common/http';
import { BaseGQLService } from 'src/app/core/services/base-gql.service';
import { environment } from 'src/environments/environment';
import { PublicResponse } from './models/PublicationsPage-response.model';
import { PublicModel } from './models/PublicationsPage.model';


@Injectable({
  providedIn: 'root',
})
export class PublicService extends BaseGQLService<any> {
  getDynamicBreadcrumbTitle(): import("rxjs").Observable<string> {
    throw new Error('Method not implemented.');
  }
  constructor(
    protected override httpLink: HttpLink,
    public override apollo: Apollo,
    protected override transferState: TransferState,
    private http: HttpClient
  ) {
    super(
      {
        typeId: '',
        model: PublicModel,
        clientName: 'PublicService',
        url: `${environment.serverUrl}/api/content/acer/graphql`,
        rootTypeName: 'queryPublicationsPageContents',
        disableCache: true,
      },
      httpLink,
      apollo,
      transferState,
    );
  }


}


